import SingleProductForm from "JS/classes/SingleProductForm";
import "fslightbox";

const initSingleProductForm = () => {
    const form = document.querySelector('[data-product-form]');

    new SingleProductForm(form);
};

(() => {
    initSingleProductForm();
})();
